import React,{useEffect,useState} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import DataInsightsandReports from '../../Components/DataInsightsandReports';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import { CardLink } from 'react-bootstrap';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import faker from 'faker';
import AuthUser from '../../AuthUser';
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);







function CustomersInsights() {
  const{http,getUser}=AuthUser()
  let userdetails = getUser()
  const[yeardata,setYeardata]=useState([])
  const[monthdata,setMonthdata]=useState([])
  const[today,setToday]=useState(0)
  const[weekly,setWeekly]=useState(0)
  const[quarter,setQuarter]=useState([])
  const options = {
    plugins: {
      title: {
        display: true,
        text: '',
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };
  
  const labels = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  
  // Fix Quarterly Data Processing
  const quarterLabels = ["Q1 Jan - Mar", "Q2 Apr - Jun", "Q3 Jul - Sep", "Q4 Oct - Dec"];
  const counts = [0, 0, 0, 0];

  quarter.forEach((item) => {
      if (item.quarter_label === "Q1 Jan - Mar") counts[0] = item.count;
      else if (item.quarter_label === "Q2 Apr - Jun") counts[1] = item.count;
      else if (item.quarter_label === "Q3 Jul - Sep") counts[2] = item.count;
      else if (item.quarter_label === "Q4 Oct - Dec") counts[3] = item.count;
  });

  const Quarterly = {
    labels: quarterLabels,
    datasets: [
      {
        label: 'Total Customers',
        data: counts,
        backgroundColor: [
          'rgba(48, 192, 205)',
          'rgba(39, 69, 104)',
          'rgba(248, 180, 21)',
          'rgba(103, 145, 36)',
  
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(54, 162, 235, 1)',
  
        ],
        borderWidth: 1,
      },
    ],
  };
  
  const data = {
    labels: ['Today', 'Weekly'],
    datasets: [
      {
        label: 'Total Customers',
        data: [today, weekly],
        backgroundColor: [
          'rgba(48, 192, 205)',
          'rgba(39, 69, 104)',
  
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
  
  
        ],
        borderWidth: 1,
      },
    ],
  };
  const monthLabels = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

// Create a default data structure with all months set to 0
const defaultMonthData = monthLabels.map((month) => ({
  month: month,
  count: 0,
}));

// Merge API response data into the default structure
const updatedMonthData = defaultMonthData.map((defaultItem, index) => {
  const foundItem = monthdata.find((item) => item.month.toUpperCase() === defaultItem.month);
  return {
    month: defaultItem.month,
    count: foundItem ? foundItem.count : 0, // Use API count if available, otherwise 0
  };
});
  const Monthly = {
    labels: monthLabels,
    
    datasets: [
      {
        label: 'Total Customers',
        //data: monthdata.map((item) => item.count), //labels.map(() => faker.datatype.number({ min: 0, max: 25 })),
        data: updatedMonthData.map((item) => item.count),
        backgroundColor: 'rgb(126, 165, 63)',
      },
  
    ],
  };
  
  const History = {
    //labels: [["2019"],["2020"],["2021"],["2022"],["2023"],["2024"],],
    labels: yeardata.map((item) => item.year.toString()),
    datasets: [
      {
        label: 'Total Customers',
        //data: labels.map(() => faker.datatype.number({ min: 0, max: 10 })),
        data: yeardata.map((item) => item.count), // Extracting customer count
        backgroundColor: 'rgb(38, 133, 198)',
      },
  
  
    ],
  };
  useEffect(() =>{
    http.get(`admin/customerInsights/${userdetails.email}`)
    .then((response) => {
      console.log(response.data)
      setYeardata(response.data.year)
      setMonthdata(response.data.month)
      setToday(response.data.today)
      setWeekly(response.data.weekly)
      setQuarter([
        { quarter_label: "Q1 Jan - Mar", count: response.data.firstqtr },
        { quarter_label: "Q2 Apr - Jun", count: response.data.secondqtr },
        { quarter_label: "Q3 Jul - Sep", count: response.data.thirdqtr },
        { quarter_label: "Q4 Oct - Dec", count: response.data.fourthqtr },
      ]);
      
    })
    .catch(function (error){

    })
  },[])
  return (
    <Container fluid>
      <DataInsightsandReports />
     
      <Container>
        <Row className='m-1'>
          <Col sm={4} className='d-flex'>
            <h6 className='fw-bold'>Customer Insights </h6>
          </Col>
          <Col sm={4} className='pb-2'>

          </Col>
          <Col sm={4} >
            <div class="dropdown float-end">
              
            </div>
          </Col>
          <Col sm={8}>
            <div class="card rounded-0" >

              <div class="card-body">
              <h5 class="card-title">Monthly</h5>
                <Bar options={options} data={Monthly} />
              </div>
            </div>

            <Row className='mt-2'>
              <Col sm={6}>
                <div class="card rounded-0" >

                  <div class="card-body">
                    <Pie data={data} />
                  </div>
                </div>

              </Col>
              <Col sm={6}>
                <div class="card rounded-0" >

                  <div class="card-body">
                    <Pie data={Quarterly} />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className='mt-2'>
            <div class="card rounded-0" >

              <div class="card-body">
                <h5 class="card-title">History</h5>
                <Bar options={options} data={History} />
              </div>
            </div>
            </Row>

          </Col>
          <Col sm={4}>
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Download Reports</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Today</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>
                <tr>
                  <td>Weekly</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>

              </tbody>
              <thead>
                <tr>
                  <th>Monthly</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Jab</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>
                <tr>
                  <td>Feb</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>
                <tr>
                  <td>Mar</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>
                <tr>
                  <td>Apr</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th>Quarterly</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Q1</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>
                <tr>
                  <td>Q2</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>
                <tr>
                  <td>Q3</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>
                <tr>
                  <td>Q4</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th>History</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2022</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#">Download	</CardLink> </td>
                </tr>
                <tr>
                  <td>2023</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#">Download</CardLink> </td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th>Current Year 2024</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Year to Date</td>
                  <td> <CardLink href="#">View </CardLink> | <CardLink href="#"> Download	</CardLink> </td>
                </tr>
              </tbody>
            </Table>
            <Card>
              <Card.Body>

              </Card.Body>
            </Card>

          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default CustomersInsights